import { useMutation } from 'react-query';
import deleteRoomTenant from '../requests/deleteRoomTenant';

const useDeleteRoomTenantMutation = (options) =>
  useMutation(
    ({ roomId, tenantId }) => deleteRoomTenant({ roomId, tenantId }),
    options
  );

export default useDeleteRoomTenantMutation;
